export const REPORTES_CONTENT = {
    lessons: {
        // reportes.tablero — «El tablero del dueño y el aviso de las 21:00» — roles: admin (Administración), owner (Dueño) — pantalla: "dashboard" — práctica: no
        "reportes.tablero": {
            summary: "Aprendés a leer el tablero, la pantalla de inicio de Dueño y Administración: los tres números (facturación, asistentes y ventas contra el objetivo del mes), el rango, el detalle, las comparativas y las alertas del día. Ves qué dice el aviso de las 21:00 que le llega al Dueño al celular y por qué un pago de la noche aparece completo en el tablero al día siguiente.",
            keyPoints: [
                "Tres números: facturación (lo que entró), asistentes (personas distintas que entraron por molinete o QR: quien vino dos veces cuenta una) y ventas de planes contra la meta del mes. Sin meta cargada dice «objetivo no cargado», no un cero.",
                "El rango se cambia entre hoy, semana, mes o fechas a elección, y todo se recalcula. Cada número se toca y abre su reporte, hasta el cobro puntual.",
                "Las comparativas van contra el período anterior y el año pasado; sin doce meses propios usan lo migrado y lo marcan. Sin base dice «sin datos comparables», nunca un 0 % inventado.",
                "A las 21:00 el Dueño recibe este resumen en el celular, con lo acumulado hasta esa hora: un pago posterior entra en el día y se ve completo en el tablero a la mañana siguiente.",
                "Si un número parece viejo, «Recalcular el rango» lo rearma desde los cobros y los ingresos. Si no se puede calcular, la pantalla lo dice en vez de mostrar un cero.",
                "Lo ven sólo Dueños y Administración: si otro rol intenta entrar, no ve nada y el intento queda registrado.",
            ],
            estimatedMin: 6,
            contentVersion: 2,
        },
        // reportes.plata — «Recaudación mensual» — roles: admin (Administración), owner (Dueño), accountant_readonly (Contador, sólo lectura) — pantalla: "reportes.recaudacion" — práctica: no
        "reportes.plata": {
            summary: "Aprendés a leer la recaudación mensual, la foto del mes del club: cuánto se recaudó, en qué sede, por qué medio y por qué concepto, contra el mes anterior y contra el mismo mes del año pasado. Ves quién puede abrirla y qué quieren decir «histórico migrado» y «sin datos comparables».",
            keyPoints: [
                "La ven los Dueños, Administración y el contador (en sólo lectura). Coordinación, encargados y recepción no: miran lo suyo en el reporte de facturación.",
                "Elegís el mes y, si querés, una sede; si no, ves el consolidado del club. Lo recaudado suma cuotas, planes, matrículas, kiosko y convenios, con las dos bases al lado: el mes anterior y el mismo mes del año pasado.",
                "Abajo, el mes abierto por sede, por medio de pago (efectivo, terminal, débito, transferencia, Mercado Pago) y por concepto.",
                "Mientras no haya doce meses propios, la comparación con el año pasado usa los datos de los sistemas anteriores, marcados «histórico migrado». Sin base dice «sin datos comparables», nunca un 0 %.",
                "Si alguien sin permiso intenta abrirla, por ejemplo escribiendo la dirección a mano, el sistema le dice que su rol no ve ese dato y el intento queda registrado. Mirar el total del club también queda anotado.",
                "Dueños y Administración la exportan en CSV, Excel o PDF, y cada exportación queda registrada.",
            ],
            estimatedMin: 6,
            contentVersion: 3,
        },
        // reportes.facturacion — «El reporte de facturación» — roles: receptionist (Recepcionista), branch_manager (Encargado de sede), intersede_coordinator (Coordinador intersedes), admin (Administración), owner (Dueño) — pantalla: "reportes.facturacion" — práctica: no
        "reportes.facturacion": {
            summary: "Aprendés a usar el reporte de facturación: cuánto entró por día o por mes, abierto por sede, medio de pago, concepto y actividad, con los planes vendidos y su vendedor. Ves cómo abrir cada número hasta el cobro puntual, qué parte del reporte le toca ver a cada rol y cómo leer un cero medido.",
            keyPoints: [
                "Recepción y encargado ven sólo la facturación del día de su sede: si recepción pide más de un día, el sistema le dice que no y por qué, en vez de recortarlo en silencio. Coordinación ve todas las sedes pero no el consolidado, que es de Dueños y Administración.",
                "Filtrás por período, sede, medio de pago, concepto y actividad. Arriba: lo facturado, la cantidad de cobros y los planes vendidos.",
                "Un cobro que pagó varias cosas se reparte entre sus conceptos en proporción a lo que cada uno debía, sin perder un centavo.",
                "Por actividad, la vista diaria muestra sólo lo cobrado directo (extras, Reformer, eventos, clases de prueba); la mensual suma la parte del pase libre repartida según los presentes. Por eso en la diaria dice «no aplica» en vez de un cero.",
                "Los planes vendidos aparecen con su vendedor, que es lo que suma al objetivo de recepción; una venta online no se atribuye a nadie. Cada cobro abre su detalle y la ficha del socio; Dueños y Administración llegan también a su auditoría.",
                "Un cobro no se modifica: una corrección es un documento nuevo que lo referencia. «Ningún cobro con esos filtros» es un cero medido, distinto de «no se pudo cargar».",
            ],
            estimatedMin: 8,
            contentVersion: 2,
        },
        // reportes.resultado — «Resultado por sede y por actividad» — roles: admin (Administración), owner (Dueño) — pantalla: "contable.resultado" — práctica: no
        "reportes.resultado": {
            summary: "Aprendés a leer el resultado del mes de cada sede y del club: ingresos (membresías y planes, kiosko y convenios) menos egresos aprobados, con los gastos de Central repartidos entre las sedes. Ves también la vista por actividad, que muestra el margen de cada disciplina y con qué criterio se calculó cada cifra.",
            keyPoints: [
                "Ingresos: membresías y planes, kiosko y convenios, imputados a la sede donde entró la plata. Egresos: sólo los aprobados; uno pendiente de aprobación no aparece.",
                "Central es una sede que no existe físicamente: junta los gastos de todo el club (contador, impuestos generales, sueldos de administración) y se reparte entre las sedes; por defecto, en proporción a lo que facturó cada una. El Dueño puede cambiarlo a partes iguales o a pesos manuales.",
                "Una sede en rojo no siempre es un mal mes: los gastos cuentan el mes en que se aprueban, y un alquiler adelantado o una compra grande pueden cargar todo en un mes.",
                "Por actividad: ingreso directo más la parte del pase libre repartida según los presentes, menos los costos directos (horas de clase liquidadas y gastos marcados con esa actividad). Lo que queda es el margen.",
                "Los costos comunes (alquiler, recepción, limpieza) por defecto no se reparten: se muestran aparte. Que no se repartan no es que le tocó cero: es el criterio elegido, y cada cifra repartida dice cómo se repartió.",
                "Lo ven sólo el Dueño y Administración; los criterios los cambia únicamente el Dueño. Se exporta, y cada exportación queda registrada.",
            ],
            estimatedMin: 9,
            contentVersion: 2,
        },
        // reportes.socios — «Socios activos» — roles: receptionist (Recepcionista), branch_manager (Encargado de sede), intersede_coordinator (Coordinador intersedes), admin (Administración), owner (Dueño) — pantalla: "reportes.socios-activos" — práctica: no
        "reportes.socios": {
            summary: "Aprendés a leer el reporte de socios activos: cuántos socios hay a una fecha, con la regla con la que se contaron a la vista, por la sede donde se asociaron y mes a mes en la serie histórica. Ves cómo la tolerancia mueve el número y por qué «no se pudo medir» no es un mes en cero.",
            keyPoints: [
                "Activo es quien tiene la cuota al día, o una deuda dentro de los días de tolerancia. Si el club cambia la tolerancia, cambia el número. La definición completa está debajo del número.",
                "Elegís la fecha (arranca en hoy, pero sirve cualquier día) y, si querés, una sede. Recepción y encargado ven su sede; los demás, el club completo.",
                "Cada socio cuenta en la sede donde se asoció, aunque entrene en otra: la suma por sede da el total sin contar a nadie dos veces.",
                "La serie histórica muestra la foto del último día de cada mes, total y por sede. Es de encargado para arriba: recepción ve el número de su sede, pero no la serie.",
                "Un mes anterior a los datos del sistema dice «no se pudo medir»: el club existía, pero el sistema todavía no contaba. No es cero socios.",
                "La tolerancia no se cambia desde acá. Se exporta, y cada exportación queda registrada.",
            ],
            estimatedMin: 6,
            contentVersion: 3,
        },
        // reportes.asistencia — «El reporte de asistencia» — roles: receptionist (Recepcionista), branch_manager (Encargado de sede), intersede_coordinator (Coordinador intersedes), admin (Administración), owner (Dueño) — pantalla: "reportes.asistencia" — práctica: no
        "reportes.asistencia": {
            summary: "Aprendés a leer el reporte de asistencia: cuánta gente vino, contada como personas únicas, por día, sede, franja horaria y actividad, con los visitantes de SportClub y Wellhub aparte pero dentro del total. Ves por qué la serie diaria no se suma, para qué sirve cada apertura y cómo leer un cero medido.",
            keyPoints: [
                "El número grande son personas únicas: quien vino cinco veces en la semana es una persona. Al lado se separan socios, visitantes y clases de prueba, y aparte los ingresos por convenio.",
                "Filtrás por período (arranca en la última semana), sede, local (una vez elegida la sede, si tiene más de uno) y actividad. Recepción y encargado ven su sede.",
                "La serie por día no se suma: cada día cuenta sus propias personas, y sumar a ojo cuenta dos veces a quien vino dos días.",
                "La franja horaria muestra dónde se junta la gente, para decidir la grilla. Por actividad muestra los presentes, la misma base con la que se reparte el pase libre.",
                "Los visitantes de SportClub y Wellhub van aparte pero dentro del total: ocupan cupo, y son la base para cruzar con la liquidación de cada convenio.",
                "El período máximo es de un año por consulta. Un cero es un cero medido; si algo no se pudo medir, lo dice con esas palabras. Se exporta, y cada exportación queda registrada.",
            ],
            estimatedMin: 6,
            contentVersion: 2,
        },
        // reportes.en-riesgo — «No renovados y en riesgo» — roles: receptionist (Recepcionista), branch_manager (Encargado de sede), intersede_coordinator (Coordinador intersedes), admin (Administración), owner (Dueño) — pantalla: "reportes.en-riesgo" — práctica: no
        "reportes.en-riesgo": {
            summary: "Aprendés a usar la lista de socios en riesgo: los que llevan quince días o más sin venir o tienen la cuota vencida, con el motivo, el último ingreso, la deuda y el estado del contacto de retención. Ves cómo distinguir «nunca vino» de «dejó de venir» y por qué «sin contacto registrado» no significa que nadie llamó.",
            keyPoints: [
                "Entra a la lista quien lleva 15 días o más sin venir (el umbral por defecto) o tiene la cuota vencida. Un socio puede estar por las dos razones a la vez.",
                "«Nunca vino» es alguien que se asoció y no registró un solo ingreso: no es lo mismo que dejar de venir, y suele ser más urgente.",
                "Podés filtrar por sede y cambiar los días sin venir para esta consulta, sin tocar el umbral del club. Recepción y encargado ven su sede.",
                "La última columna muestra el contacto de retención, que escribe el seguimiento de socios y acá sólo se lee. «Sin contacto registrado» quiere decir que no hay una gestión cargada, no que nadie llamó.",
                "Cada nombre abre la ficha del socio; coordinación, Administración y Dueños pueden armar una campaña de retención desde arriba. La lista se exporta y queda registrado quién la exportó.",
                "Desde acá no se edita nada. «Ningún socio en riesgo» es un resultado medido.",
            ],
            estimatedMin: 5,
            contentVersion: 2,
        },
        // reportes.objetivos — «Objetivos por recepcionista» — roles: receptionist (Recepcionista), branch_manager (Encargado de sede), intersede_coordinator (Coordinador intersedes), admin (Administración), owner (Dueño) — pantalla: "reportes.objetivos" — práctica: no
        "reportes.objetivos": {
            summary: "Aprendés a seguir en vivo el objetivo mensual de venta de planes de cada recepcionista: lo vendido contra la meta, la barra de avance y en qué sede se hizo cada venta. Ves qué ventas suman, quién ve qué y dónde se cargan los objetivos.",
            keyPoints: [
                "Recepción ve sólo sus ventas; el encargado, las de su sede; Dueños y Administración, las de todas las recepcionistas del club.",
                "Cada tarjeta muestra lo vendido contra el objetivo, la barra y el porcentaje del mes; la barra se pone verde al llegar al 100 %.",
                "Suman los planes que vendiste vos: cada venta queda con su vendedor. Una venta hecha toda por la app no se atribuye a nadie.",
                "El objetivo es de la persona, no de la sede: si rotás de sede a mitad de mes, suman tus ventas en cualquier sede.",
                "Es una vista: no se cambia ningún objetivo ni se corrige una venta. Los objetivos y la escala de comisión los cargan Administración o el Dueño en Personal → Objetivos de recepción.",
                "Sin meta cargada la tarjeta dice «objetivo no cargado»: no es un 0 %, falta el dato, y hay que avisarle a Administración.",
            ],
            estimatedMin: 5,
            contentVersion: 2,
        },
        // reportes.alertas-negocio — «Alertas del negocio» — roles: intersede_coordinator (Coordinador intersedes), admin (Administración), owner (Dueño) — pantalla: "reportes.alertas-negocio" — práctica: no
        "reportes.alertas-negocio": {
            summary: "Aprendés cómo funcionan las dos alertas del negocio: caída de asistencia y caída de facturación de una sede contra su promedio del mismo día de la semana. Ves cuándo se evalúan, qué días no cuentan, quién las configura, por qué un cambio lleva motivo y qué hacer cuando salta una.",
            keyPoints: [
                "Todas las noches a las 21:10 se compara el día de cada sede con el promedio del mismo día de la semana en las últimas semanas (por defecto 4). Si cayó más que el umbral (por defecto 20 %), sale el aviso.",
                "Un umbral más bajo avisa por caídas más chicas. Guardar un cambio pide motivo y rige desde la evaluación de esa noche.",
                "La de asistencia la configuran el Dueño y el coordinador intersedes; la de facturación la ve y la configura sólo el Dueño. Administración consulta la pantalla.",
                "Los feriados y los días en que la sede no abre no disparan ni ensucian el promedio. Sin días comparables suficientes no alerta. Con el interruptor general apagado nadie recibe nada, y el sistema lo advierte.",
                "El historial muestra cada disparo: día, sede, lo que hubo, el promedio, la caída y el texto del aviso.",
                "Cuando salta una: abrí el reporte de ese día y esa sede, buscá algo que lo explique (una clase cancelada, un corte) y revisá el cierre de caja del turno.",
            ],
            estimatedMin: 5,
            contentVersion: 2,
        },
        // reportes.alertas-seguridad — «Alertas de seguridad» — roles: intersede_coordinator (Coordinador intersedes), admin (Administración), owner (Dueño) — pantalla: "roles.alertas-seguridad" — práctica: no
        "reportes.alertas-seguridad": {
            summary: "Aprendés qué acciones disparan una alerta de seguridad, a quién le llegan y cómo se revisa una. Ves por qué avisan en el momento y no al día siguiente, quién puede prenderlas, apagarlas o cambiar sus umbrales, y por qué apagar una no borra nada.",
            keyPoints: [
                "Disparan alerta: cobro o venta anulados, descuento o diferencia de caja sobre el umbral, pago corregido, ingreso autorizado con deuda, cambios en la lista de precios o en los roles, altas y bajas de usuarios, exportaciones masivas, congelamientos especiales e intentos fallidos de entrar al sistema.",
                "Avisan en el momento del hecho. De fábrica vienen todas activas y les llegan al Dueño y a Administración.",
                "El Dueño y el coordinador intersedes las prenden o apagan; los umbrales de plata (por defecto, descuento de más del 10 % y diferencia de caja de más de $10.000) los cambia sólo el Dueño. Administración ve el catálogo y el historial.",
                "Cada disparo del historial lleva a su línea de auditoría: quién fue, en qué sede, desde dónde y con qué motivo. El historial no se edita ni se borra.",
                "Apagar una alerta no borra nada: la acción queda igual en la auditoría, sólo que nadie recibe el aviso.",
                "Cuando llega una: primero leé el motivo escrito; si no hay explicación, hablá con la persona, y si es de caja, mirá Diferencias y arqueos.",
            ],
            estimatedMin: 6,
            contentVersion: 2,
        },
        // reportes.auditoria — «Auditoría: quién hizo qué, cuándo y por qué» — roles: admin (Administración), owner (Dueño) — pantalla: "roles.auditoria" — práctica: sí
        "reportes.auditoria": {
            summary: "Aprendés a usar el registro de auditoría, la base de que cada peso tenga dueño: cada acción con quién la hizo, cuándo, en qué sede, desde dónde y qué había antes y después. Ves cómo filtrar, cómo usar «Sólo excepciones», cómo llegar desde un cobro y por qué nadie puede editarlo ni borrarlo.",
            keyPoints: [
                "Cada vez que alguien crea, cambia o anula algo queda anotado quién, cuándo, en qué sede, desde qué superficie (portal, portal de profesores, app de socios, tablet del kiosko, molinete o el propio sistema) y el antes y después. Lo consultan sólo Dueños y Administración, y hasta mirarla queda registrado.",
                "Se filtra por sede, superficie, fechas, acción o entidad. «Sólo excepciones» deja lo que se salió de la regla (descuentos fuera de lista, ingresos con deuda, anulaciones, congelamientos especiales, correcciones), cada una con su motivo.",
                "El detalle muestra el antes, el después, la IP y el dispositivo. Contraseñas, PIN y códigos nunca aparecen: el sistema los tapa antes de guardar.",
                "Desde un cobro, «Ver su auditoría» abre la lista filtrada por ese cobro. Exportar también queda auditado, y una exportación muy grande dispara la alerta de exportación masiva.",
                "Nadie edita ni borra una línea, ni el Dueño: un error se corrige con una acción nueva que queda al lado de la original.",
                "Una vez por semana conviene mirar las excepciones con sus motivos y las exportaciones grandes.",
            ],
            estimatedMin: 8,
            contentVersion: 2,
        },
    },
    questions: [
        // ── reportes.tablero ────────────────────────────────────────────────────
        {
            id: "reportes.tablero#1",
            lessonKey: "reportes.tablero",
            prompt: "A las 21:00 le llegó al Dueño el resumen del día. A las 23:50 un socio paga la cuota desde la app. ¿Dónde aparece ese pago?",
            options: [
                {
                    id: "a",
                    text: "En un segundo aviso que le llega al Dueño a medianoche con lo que faltaba.",
                },
                {
                    id: "b",
                    text: "En la facturación del día siguiente, porque el día se cierra con el aviso de las 21:00.",
                },
                {
                    id: "c",
                    text: "Entra en el día y se ve completo en el tablero a la mañana siguiente.",
                },
                {
                    id: "d",
                    text: "En ningún lado hasta que alguien toque Recalcular el rango.",
                },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, el aviso de las 21:00 es lo acumulado hasta esa hora. Un pago a las once y cincuenta entra en el día y se ve completo en el tablero a la mañana siguiente.",
        },
        {
            id: "reportes.tablero#2",
            lessonKey: "reportes.tablero",
            prompt: "Juana Prueba entró hoy por molinete a la mañana y volvió a la tarde. ¿Cuánto suma al número de asistentes del día?",
            options: [
                {
                    id: "a",
                    text: "Uno: se cuentan personas distintas.",
                },
                {
                    id: "b",
                    text: "Dos, porque el tablero cuenta cada vez que alguien pasa el molinete.",
                },
                {
                    id: "c",
                    text: "Ninguno hasta que termine el día y se cierre la asistencia.",
                },
                {
                    id: "d",
                    text: "Dos si entró por molinete y uno si la segunda vez entró por QR.",
                },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, los asistentes son personas distintas que entraron por molinete o QR: si alguien vino dos veces, cuenta una.",
        },
        {
            id: "reportes.tablero#3",
            lessonKey: "reportes.tablero",
            prompt: "En «Ventas contra objetivo» el tablero dice «objetivo no cargado». ¿Cómo lo leés?",
            options: [
                {
                    id: "a",
                    text: "Que este mes no se vendió ningún plan todavía.",
                },
                {
                    id: "b",
                    text: "Que la venta va al 0 % de la meta y hay que apurar a recepción.",
                },
                {
                    id: "c",
                    text: "Que el sistema no pudo calcular las ventas y hay que tocar Recalcular el rango.",
                },
                {
                    id: "d",
                    text: "Que falta cargar la meta del mes: no es un cero.",
                },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, si la meta no está cargada el tablero dice objetivo no cargado, no un cero: lo que falta es el dato, no las ventas.",
        },
        {
            id: "reportes.tablero#4",
            lessonKey: "reportes.tablero",
            prompt: "Entrás al sistema y el tablero dice «No se pudieron cargar los números del día». ¿Qué significa?",
            options: [
                {
                    id: "a",
                    text: "Que hoy no entró ni un peso ni una persona: es un día en cero.",
                },
                {
                    id: "b",
                    text: "El sistema no pudo calcular: esperás un momento y volvés a entrar.",
                },
                {
                    id: "c",
                    text: "Que tu usuario perdió el permiso para ver la facturación del club y tenés que pedirlo.",
                },
                {
                    id: "d",
                    text: "Que el aviso de las 21:00 de ayer no salió y hay que mandarlo a mano.",
                },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, si el sistema no puede calcular te lo dice, y no te muestra un cero en su lugar, porque un cero querría decir que no entró un peso. Esperás un momento y volvés a entrar.",
        },
        // ── reportes.plata ──────────────────────────────────────────────────────
        {
            id: "reportes.plata#1",
            lessonKey: "reportes.plata",
            prompt: "Un encargado de sede escribe a mano la dirección de Recaudación mensual para ver cuánto recaudó el club. ¿Qué pasa?",
            options: [
                {
                    id: "a",
                    text: "La ve, pero sólo con los números de su sede.",
                },
                {
                    id: "b",
                    text: "El sistema le dice que su rol no ve ese dato y el intento queda registrado.",
                },
                {
                    id: "c",
                    text: "La ve completa, porque entrar por la dirección directa saltea el menú de su rol.",
                },
                {
                    id: "d",
                    text: "No la ve en pantalla, pero la puede exportar en Excel con el botón Exportar.",
                },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, la recaudación del club la ven sólo Dueños, Administración y el contador. Si alguien sin permiso intenta abrirla escribiendo la dirección, el sistema le dice que su rol no ve ese dato y el intento queda registrado; la exportación tampoco es una puerta de atrás.",
        },
        {
            id: "reportes.plata#2",
            lessonKey: "reportes.plata",
            prompt: "El sistema todavía no tiene doce meses propios. ¿Contra qué compara el mes con el mismo mes del año pasado?",
            options: [
                {
                    id: "a",
                    text: "Contra cero, así que la variación sale siempre positiva.",
                },
                {
                    id: "b",
                    text: "Contra el mes anterior, que reemplaza al del año pasado hasta tener historia.",
                },
                {
                    id: "c",
                    text: "Contra un promedio estimado por el sistema a partir de los meses que sí tiene.",
                },
                {
                    id: "d",
                    text: "Contra los datos de los sistemas anteriores, marcados «histórico migrado».",
                },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, mientras el sistema no tenga doce meses propios, la comparación contra el año pasado usa los datos que vinieron de los sistemas anteriores, marcados como histórico migrado.",
        },
        {
            id: "reportes.plata#3",
            lessonKey: "reportes.plata",
            prompt: "En una comparación no hay ningún dato del período base. ¿Qué muestra la recaudación?",
            options: [
                {
                    id: "a",
                    text: "«Sin datos comparables», en lugar de un porcentaje.",
                },
                {
                    id: "b",
                    text: "Una variación del 0 %, porque no hubo cambio contra nada.",
                },
                {
                    id: "c",
                    text: "Una variación del 100 %, porque todo lo del mes es nuevo.",
                },
                {
                    id: "d",
                    text: "Nada: la tarjeta desaparece hasta que haya base para comparar.",
                },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, si no hay base dice sin datos comparables, nunca un cero por ciento inventado.",
        },
        {
            id: "reportes.plata#4",
            lessonKey: "reportes.plata",
            prompt: "¿Qué suma la tarjeta de lo recaudado en el mes?",
            options: [
                {
                    id: "a",
                    text: "Sólo las cuotas y los planes: el kiosko y los convenios se ven en otro reporte.",
                },
                {
                    id: "b",
                    text: "Sólo lo cobrado en efectivo y por terminal, sin transferencias.",
                },
                {
                    id: "c",
                    text: "Cuotas, planes, matrículas, kiosko y convenios.",
                },
                {
                    id: "d",
                    text: "Lo recaudado menos los gastos aprobados del mes.",
                },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, lo recaudado en el mes suma cuotas, planes, matrículas, kiosko y convenios, y abajo se abre por sede, medio de pago y concepto. Los gastos se restan en otro reporte, el de resultado.",
        },
        // ── reportes.facturacion ────────────────────────────────────────────────
        {
            id: "reportes.facturacion#1",
            lessonKey: "reportes.facturacion",
            prompt: "Estás en recepción y pedís el reporte de facturación de toda la semana. ¿Qué pasa?",
            options: [
                {
                    id: "a",
                    text: "Te muestra sólo el día de hoy, recortado, sin avisarte.",
                },
                {
                    id: "b",
                    text: "Te muestra la semana completa, pero sin los totales.",
                },
                {
                    id: "c",
                    text: "El sistema te dice que no y por qué: recepción ve sólo el día de su sede.",
                },
                {
                    id: "d",
                    text: "Te muestra la semana de todas las sedes, porque el filtro de sede queda vacío.",
                },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, recepción y encargado ven sólo la facturación del día de su sede. Si pedís más de un día, el sistema no te recorta el reporte en silencio: te dice que no y por qué.",
        },
        {
            id: "reportes.facturacion#2",
            lessonKey: "reportes.facturacion",
            prompt: "En la vista diaria, por actividad, una disciplina del pase libre dice «no aplica». ¿Por qué?",
            options: [
                {
                    id: "a",
                    text: "Porque la diaria muestra sólo lo cobrado directo; el pase libre se reparte en la mensual.",
                },
                {
                    id: "b",
                    text: "Porque esa actividad no tuvo presentes ese día y el sistema no la quiere mostrar en cero.",
                },
                {
                    id: "c",
                    text: "Porque esa actividad no está cargada en la grilla de la sede.",
                },
                {
                    id: "d",
                    text: "Porque el pase libre no se reparte nunca entre actividades.",
                },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, en la vista diaria sólo ves lo cobrado directo por cada actividad: extras, Reformer, eventos, clases de prueba. En la mensual se suma la parte del pase libre, repartida según los presentes del mes. Por eso la diaria dice no aplica, en vez de un cero.",
        },
        {
            id: "reportes.facturacion#3",
            lessonKey: "reportes.facturacion",
            prompt: "Juana Prueba pagó la cuota y una clase extra en un solo cobro. ¿Cómo aparece ese cobro en la apertura por concepto?",
            options: [
                {
                    id: "a",
                    text: "Todo en la cuota, que es el concepto principal del cobro.",
                },
                {
                    id: "b",
                    text: "Mitad y mitad entre los dos conceptos, sin importar lo que costaba cada uno.",
                },
                {
                    id: "c",
                    text: "En un concepto aparte llamado «varios», porque no se puede separar.",
                },
                {
                    id: "d",
                    text: "Repartido en proporción a lo que debía cada uno, sin perder un centavo.",
                },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, si un cobro pagó varias cosas juntas, se reparte entre sus conceptos en proporción a lo que cada uno debía, sin perder un centavo.",
        },
        {
            id: "reportes.facturacion#4",
            lessonKey: "reportes.facturacion",
            prompt: "Filtrás por Mercado Pago en una sede y el reporte dice «ningún cobro con esos filtros». ¿Cómo lo leés?",
            options: [
                {
                    id: "a",
                    text: "Que el reporte no se pudo cargar y hay que llamar a soporte.",
                },
                {
                    id: "b",
                    text: "Es un cero medido: la consulta corrió y no encontró cobros.",
                },
                {
                    id: "c",
                    text: "Que tu rol no puede ver los cobros por Mercado Pago de esa sede.",
                },
                {
                    id: "d",
                    text: "Que los cobros de Mercado Pago todavía no se sincronizaron y aparecen mañana.",
                },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, ningún cobro con esos filtros es un cero medido: la consulta corrió y no encontró nada. Si el reporte no se pudo cargar, te lo dice así, sin inventar ceros.",
        },
        // ── reportes.resultado ──────────────────────────────────────────────────
        {
            id: "reportes.resultado#1",
            lessonKey: "reportes.resultado",
            prompt: "Cargaste un gasto grande de mantenimiento que todavía está pendiente de aprobación. ¿Aparece en el resultado de la sede?",
            options: [
                {
                    id: "a",
                    text: "Sí, como egreso de la sede, desde el día en que se cargó.",
                },
                {
                    id: "b",
                    text: "Sí, pero en Central, hasta que alguien lo apruebe.",
                },
                {
                    id: "c",
                    text: "Sí, marcado como estimado, para no ocultarlo.",
                },
                {
                    id: "d",
                    text: "No: en el resultado sólo cuentan los egresos aprobados.",
                },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, en los egresos sólo cuentan los aprobados: un gasto que todavía está pendiente de aprobación no aparece.",
        },
        {
            id: "reportes.resultado#2",
            lessonKey: "reportes.resultado",
            prompt: "Una sede aparece en rojo el mes en que se aprobó el alquiler adelantado de tres meses. ¿Cómo lo leés?",
            options: [
                {
                    id: "a",
                    text: "Es un mal mes de esa sede y hay que revisar sus ventas.",
                },
                {
                    id: "b",
                    text: "No siempre es un mal mes: el gasto cuenta el mes en que se aprueba.",
                },
                {
                    id: "c",
                    text: "Es un error del reporte: el alquiler debería estar en Central y repartido.",
                },
                {
                    id: "d",
                    text: "Es porque los ingresos de esa sede se pasaron a Central ese mes.",
                },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, si una sede aparece en rojo no siempre es un mal mes: los gastos cuentan el mes en que se aprueban, y un alquiler adelantado o una compra grande de kiosko pueden cargar todo en un mes.",
        },
        {
            id: "reportes.resultado#3",
            lessonKey: "reportes.resultado",
            prompt: "Los honorarios del contador del club van a Central. ¿Cómo terminan en el resultado de cada sede?",
            options: [
                {
                    id: "a",
                    text: "Repartidos entre las sedes; por defecto, según lo que facturó cada una.",
                },
                {
                    id: "b",
                    text: "No terminan en ninguna: Central se muestra aparte y no afecta a las sedes.",
                },
                {
                    id: "c",
                    text: "Todos en la sede más grande, que es la que más usa al contador.",
                },
                {
                    id: "d",
                    text: "En partes iguales siempre, porque así lo fija el sistema y no se puede cambiar.",
                },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, Central junta los gastos de todo el club, como el contador, y se reparte entre las tres sedes. Por defecto, en proporción a lo que facturó cada una; el Dueño puede cambiarlo a partes iguales o a pesos manuales.",
        },
        {
            id: "reportes.resultado#4",
            lessonKey: "reportes.resultado",
            prompt: "En Por actividad, el alquiler no aparece descontado de ninguna disciplina. ¿Quiere decir que a cada actividad le tocó cero de alquiler?",
            options: [
                {
                    id: "a",
                    text: "Sí: el alquiler no se considera un costo del club.",
                },
                {
                    id: "b",
                    text: "Sí: el sistema lo descuenta sólo de la actividad con más presentes.",
                },
                {
                    id: "c",
                    text: "No: es un costo común que por defecto no se reparte y se muestra aparte.",
                },
                {
                    id: "d",
                    text: "No: el alquiler se descuenta de cada actividad recién a fin de año.",
                },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, el alquiler, la recepción y la limpieza son costos comunes: por defecto no se reparten y se muestran aparte. Que no se repartan no es que le tocó cero, es el criterio elegido; el Dueño puede repartirlos por presentes o por ingreso.",
        },
        // ── reportes.socios ─────────────────────────────────────────────────────
        {
            id: "reportes.socios#1",
            lessonKey: "reportes.socios",
            prompt: "El club amplía los días de tolerancia de deuda. ¿Qué pasa con el número de socios activos?",
            options: [
                {
                    id: "a",
                    text: "Puede cambiar: activo es quien está al día o dentro de la tolerancia.",
                },
                {
                    id: "b",
                    text: "Nada: la tolerancia sólo afecta al molinete, no al conteo de socios.",
                },
                {
                    id: "c",
                    text: "Cambia recién el mes siguiente, cuando se cierra la serie histórica.",
                },
                {
                    id: "d",
                    text: "Baja, porque se cuentan aparte los que están dentro de la tolerancia.",
                },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, activo es quien tiene la cuota al día o una deuda dentro de los días de tolerancia, que se ven en la tarjeta del medio. Si el club cambia la tolerancia, cambia este número.",
        },
        {
            id: "reportes.socios#2",
            lessonKey: "reportes.socios",
            prompt: "Una socia se asoció en Martínez pero entrena siempre en Olivos. ¿En qué sede cuenta?",
            options: [
                {
                    id: "a",
                    text: "En Olivos, porque es donde registra sus ingresos.",
                },
                {
                    id: "b",
                    text: "En las dos, porque usa las dos sedes.",
                },
                {
                    id: "c",
                    text: "En Martínez, donde se asoció.",
                },
                {
                    id: "d",
                    text: "En la sede donde pagó la última cuota.",
                },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, cada socio cuenta en la sede donde se asoció, aunque entrene en otra. Por eso la suma por sede da el total, sin contar a nadie dos veces.",
        },
        {
            id: "reportes.socios#3",
            lessonKey: "reportes.socios",
            prompt: "En la serie histórica, un mes viejo dice «no se pudo medir». ¿Qué significa?",
            options: [
                {
                    id: "a",
                    text: "Que ese mes el club no tuvo socios activos.",
                },
                {
                    id: "b",
                    text: "Que es anterior a los datos del sistema: el club existía, pero no contaba.",
                },
                {
                    id: "c",
                    text: "Que hubo un error ese mes y hay que pedir que se recalcule.",
                },
                {
                    id: "d",
                    text: "Que ese mes todos los socios tenían deuda fuera de la tolerancia.",
                },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, si un mes es anterior a los datos del sistema dice no se pudo medir: el club existía, pero el sistema todavía no contaba. No es cero socios.",
        },
        {
            id: "reportes.socios#4",
            lessonKey: "reportes.socios",
            prompt: "Estás en recepción y querés ver cómo evolucionaron los socios de tu sede en los últimos seis meses. ¿Qué te muestra el reporte?",
            options: [
                {
                    id: "a",
                    text: "La serie completa de tu sede, igual que a un encargado.",
                },
                {
                    id: "b",
                    text: "La serie de todo el club, porque la histórica no se filtra por sede.",
                },
                {
                    id: "c",
                    text: "La serie, pero sólo de los meses en que trabajaste vos.",
                },
                {
                    id: "d",
                    text: "El número de tu sede, pero no la serie, que es de encargado para arriba.",
                },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, en recepción ves el número de tu sede, pero la serie histórica es de encargado para arriba: te aparece que tu rol no ve ese dato.",
        },
        // ── reportes.asistencia ─────────────────────────────────────────────────
        {
            id: "reportes.asistencia#1",
            lessonKey: "reportes.asistencia",
            prompt: "Sumás a mano las personas de cada día de la semana y te da más que el número grande del período. ¿Por qué?",
            options: [
                {
                    id: "a",
                    text: "Porque el número grande no incluye a los visitantes de convenio.",
                },
                {
                    id: "b",
                    text: "La serie diaria no se suma: quien vino dos días se cuenta dos veces.",
                },
                {
                    id: "c",
                    text: "Porque algún día quedó sin medir y el sistema lo completa con un promedio.",
                },
                {
                    id: "d",
                    text: "Porque el número grande cuenta sólo los ingresos por molinete y no los de QR.",
                },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, en Por día cada día cuenta sus propias personas, y el número grande son personas únicas del período. Por eso la serie no se suma: si sumás los días a ojo, contás dos veces a quien vino dos días.",
        },
        {
            id: "reportes.asistencia#2",
            lessonKey: "reportes.asistencia",
            prompt: "¿Cómo aparecen en el reporte los visitantes de SportClub y Wellhub?",
            options: [
                {
                    id: "a",
                    text: "No aparecen: sólo se cuentan los socios del club.",
                },
                {
                    id: "b",
                    text: "Sólo dentro del total, mezclados con los socios, sin distinguirlos.",
                },
                {
                    id: "c",
                    text: "Sólo aparte, fuera del total, porque no son socios.",
                },
                {
                    id: "d",
                    text: "Aparte, pero dentro del total: ocupan cupo y son gente en el club.",
                },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, los visitantes de convenio aparecen aparte, pero dentro del total: ocupan cupo y son gente en el club. Ese número es la base para cruzar con la liquidación de cada convenio.",
        },
        {
            id: "reportes.asistencia#3",
            lessonKey: "reportes.asistencia",
            prompt: "Querés decidir en qué horario abrir una clase más. ¿Qué parte del reporte te sirve?",
            options: [
                {
                    id: "a",
                    text: "La de visitantes de convenio, para ver cuándo vienen los de afuera.",
                },
                {
                    id: "b",
                    text: "El número grande del período.",
                },
                {
                    id: "c",
                    text: "Por franja horaria, que muestra dónde se junta la gente.",
                },
                {
                    id: "d",
                    text: "Por sede, que muestra los ingresos por molinete y QR de cada local.",
                },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, por franja horaria te muestra dónde se junta la gente: es la mejor pista para decidir horarios, dónde abrir una clase más y dónde sobra.",
        },
        {
            id: "reportes.asistencia#4",
            lessonKey: "reportes.asistencia",
            prompt: "Necesitás la asistencia de los últimos dos años. ¿Cómo la sacás?",
            options: [
                {
                    id: "a",
                    text: "Por partes: el período máximo de cada consulta es de un año.",
                },
                {
                    id: "b",
                    text: "En una sola consulta: elegís las dos fechas y listo.",
                },
                {
                    id: "c",
                    text: "No se puede: el reporte sólo muestra la última semana.",
                },
                {
                    id: "d",
                    text: "Pidiéndosela al Dueño, que es el único que puede ver más de un mes.",
                },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, el reporte no barre la historia entera de una vez: el período máximo es de un año. Si necesitás más, lo pedís por partes.",
        },
        // ── reportes.en-riesgo ──────────────────────────────────────────────────
        {
            id: "reportes.en-riesgo#1",
            lessonKey: "reportes.en-riesgo",
            prompt: "En la lista aparece un socio con «nunca vino». ¿Qué quiere decir y cómo lo priorizás?",
            options: [
                {
                    id: "a",
                    text: "Que vino hoy y lleva cero días sin venir, así que no hace falta llamarlo.",
                },
                {
                    id: "b",
                    text: "Que el molinete no lo reconoce y hay que revisar su huella.",
                },
                {
                    id: "c",
                    text: "Se asoció y no entró nunca: no es lo mismo que dejar de venir, y suele ser más urgente.",
                },
                {
                    id: "d",
                    text: "Que es un ex socio que se dio de baja y quedó en la lista por error.",
                },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, nunca vino es alguien que se asoció y no registró un solo ingreso. No es lo mismo que alguien que dejó de venir, y suele ser más urgente.",
        },
        {
            id: "reportes.en-riesgo#2",
            lessonKey: "reportes.en-riesgo",
            prompt: "Cambiás los días sin venir a 30 para ver sólo a los que llevan un mes sin aparecer. ¿Qué pasa con el umbral del club?",
            options: [
                {
                    id: "a",
                    text: "Nada: el cambio vale sólo para esta consulta.",
                },
                {
                    id: "b",
                    text: "Pasa a ser 30 para todos los que miren la lista desde ahora.",
                },
                {
                    id: "c",
                    text: "Pasa a ser 30, pero sólo para tu sede.",
                },
                {
                    id: "d",
                    text: "El sistema te pide motivo, porque estás cambiando una regla del club.",
                },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, podés cambiar los días sin venir para ver otra cosa, pero ese cambio vale para esta consulta: el umbral del club no se toca.",
        },
        {
            id: "reportes.en-riesgo#3",
            lessonKey: "reportes.en-riesgo",
            prompt: "Juana Prueba figura con «sin contacto registrado», pero tu compañera dice que la llamó ayer. ¿Cómo se explica?",
            options: [
                {
                    id: "a",
                    text: "Tu compañera se equivoca: si la hubiera llamado, la lista lo mostraría solo.",
                },
                {
                    id: "b",
                    text: "No hay una gestión cargada en el seguimiento de socios, no que nadie llamó.",
                },
                {
                    id: "c",
                    text: "La lista se actualiza una vez por mes, así que el llamado aparece recién el mes que viene.",
                },
                {
                    id: "d",
                    text: "Que el llamado se borró porque Juana todavía debe la cuota.",
                },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, ese dato lo escribe el seguimiento de socios y acá sólo se lee. Sin contacto registrado significa que no hay una gestión cargada, no que nadie llamó.",
        },
        {
            id: "reportes.en-riesgo#4",
            lessonKey: "reportes.en-riesgo",
            prompt: "La lista de tu sede dice «ningún socio en riesgo». ¿Cómo lo leés?",
            options: [
                {
                    id: "a",
                    text: "Que el reporte no cargó y hay que volver a entrar más tarde.",
                },
                {
                    id: "b",
                    text: "Que tu rol no puede ver la lista de socios en riesgo.",
                },
                {
                    id: "c",
                    text: "Que la lista se vació porque alguien ya llamó a todos los de la semana.",
                },
                {
                    id: "d",
                    text: "Es un resultado medido: todos vinieron dentro del umbral y están al día.",
                },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, si dice ningún socio en riesgo es un resultado medido: todos vinieron dentro del umbral y están al día.",
        },
        // ── reportes.objetivos ──────────────────────────────────────────────────
        {
            id: "reportes.objetivos#1",
            lessonKey: "reportes.objetivos",
            prompt: "Una recepcionista rota de Olivos a Martínez a mitad de mes. ¿Qué pasa con su objetivo?",
            options: [
                {
                    id: "a",
                    text: "Se reinicia en cero en Martínez y lo vendido en Olivos queda para la sede.",
                },
                {
                    id: "b",
                    text: "Se parte en dos objetivos, uno por cada sede, con la mitad de la meta cada uno.",
                },
                {
                    id: "c",
                    text: "Lo vendido en Olivos pasa a la recepcionista que la reemplaza.",
                },
                {
                    id: "d",
                    text: "Sigue siendo suyo: suman sus ventas en cualquier sede.",
                },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, el objetivo es de la persona, no de la sede: si rotás de sede a mitad de mes, suman tus ventas en cualquier sede.",
        },
        {
            id: "reportes.objetivos#2",
            lessonKey: "reportes.objetivos",
            prompt: "Un socio compró un plan él solo, todo desde la app, mientras estabas de turno. ¿A quién suma esa venta?",
            options: [
                {
                    id: "a",
                    text: "A la recepcionista que estaba de turno en su sede.",
                },
                {
                    id: "b",
                    text: "A nadie: una venta hecha toda por la app no se atribuye.",
                },
                {
                    id: "c",
                    text: "Al encargado de la sede, que firma las ventas online.",
                },
                {
                    id: "d",
                    text: "Se reparte entre todas las recepcionistas de la sede.",
                },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, suman los planes que vendiste vos, porque cada venta queda con su vendedor. Una venta hecha toda por la app no se atribuye a nadie.",
        },
        {
            id: "reportes.objetivos#3",
            lessonKey: "reportes.objetivos",
            prompt: "La tarjeta de una compañera dice «objetivo no cargado». ¿Qué hacés?",
            options: [
                {
                    id: "a",
                    text: "Le avisás a Administración para que cargue la meta: no es un 0 %, falta el dato.",
                },
                {
                    id: "b",
                    text: "Nada: quiere decir que este mes no vendió ningún plan.",
                },
                {
                    id: "c",
                    text: "Le cargás vos la meta desde esa misma tarjeta.",
                },
                {
                    id: "d",
                    text: "Exportás el reporte para que el sistema recalcule el porcentaje.",
                },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, si a alguien no le cargaron la meta la tarjeta dice objetivo no cargado. No es un cero por ciento: falta el dato, y hay que avisarle a Administración para que lo cargue.",
        },
        {
            id: "reportes.objetivos#4",
            lessonKey: "reportes.objetivos",
            prompt: "Sos encargado y querés subirle la meta del mes a una recepcionista de tu sede. ¿Dónde se hace?",
            options: [
                {
                    id: "a",
                    text: "En su tarjeta de este reporte, tocando el objetivo y escribiendo el nuevo.",
                },
                {
                    id: "b",
                    text: "En la ficha de la recepcionista, en la solapa Ventas.",
                },
                {
                    id: "c",
                    text: "En Personal → Objetivos de recepción, donde la cargan Administración o el Dueño.",
                },
                {
                    id: "d",
                    text: "En ningún lado: la meta la calcula el sistema según las ventas del mes anterior.",
                },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, esta pantalla es sólo para mirar: desde acá no se cambia ningún objetivo. Los objetivos y la escala de comisión los carga Administración o el Dueño en Personal, Objetivos de recepción.",
        },
        // ── reportes.alertas-negocio ────────────────────────────────────────────
        {
            id: "reportes.alertas-negocio#1",
            lessonKey: "reportes.alertas-negocio",
            prompt: "Un martes, una sede tuvo un 25 % menos de gente que el promedio de los martes de las últimas semanas. Con la configuración por defecto, ¿qué pasa?",
            options: [
                {
                    id: "a",
                    text: "A las 21:10 sale el aviso, porque cayó más que el umbral del 20 %.",
                },
                {
                    id: "b",
                    text: "Nada: la alerta compara contra el día anterior, no contra los martes.",
                },
                {
                    id: "c",
                    text: "Sale un aviso en el momento en que la asistencia empieza a bajar, a media tarde.",
                },
                {
                    id: "d",
                    text: "Nada: la alerta sólo salta si la caída se repite tres martes seguidos.",
                },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, todas las noches a las veintiuna y diez el sistema compara el día de cada sede con el promedio del mismo día de la semana en las últimas semanas. Si cayó más que el umbral, por defecto un veinte por ciento, manda el aviso.",
        },
        {
            id: "reportes.alertas-negocio#2",
            lessonKey: "reportes.alertas-negocio",
            prompt: "Un lunes feriado la sede estuvo cerrada. ¿Qué pasa con la alerta y con el promedio de los lunes?",
            options: [
                {
                    id: "a",
                    text: "Salta la alerta de caída, porque ese día no entró nadie.",
                },
                {
                    id: "b",
                    text: "No salta, pero el cero entra al promedio de los lunes siguientes.",
                },
                {
                    id: "c",
                    text: "No cuenta: no dispara la alerta ni ensucia el promedio.",
                },
                {
                    id: "d",
                    text: "Hay que apagar el interruptor general ese día para que no salte.",
                },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, los feriados y los días en que la sede no abre no cuentan: ni disparan alertas ni ensucian el promedio.",
        },
        {
            id: "reportes.alertas-negocio#3",
            lessonKey: "reportes.alertas-negocio",
            prompt: "Bajás el umbral de caída de asistencia al 15 % y tocás Guardar la configuración. ¿Qué pasa?",
            options: [
                {
                    id: "a",
                    text: "Se guarda en el acto y vas a recibir menos avisos que antes.",
                },
                {
                    id: "b",
                    text: "Te pide un motivo y rige desde la evaluación de esa noche.",
                },
                {
                    id: "c",
                    text: "Queda pendiente hasta que lo apruebe Administración.",
                },
                {
                    id: "d",
                    text: "Rige recién dentro de cuatro semanas, cuando se renueve la ventana de comparación.",
                },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, un umbral más bajo avisa por caídas más chicas. Al guardar, el sistema pide un motivo, porque cambiar una alerta es una decisión que tiene que quedar explicada, y rige desde la evaluación de esa noche.",
        },
        {
            id: "reportes.alertas-negocio#4",
            lessonKey: "reportes.alertas-negocio",
            prompt: "Te llega la alerta de caída de facturación de una sede. ¿Qué hacés primero?",
            options: [
                {
                    id: "a",
                    text: "Subís el umbral para que no vuelva a saltar por algo así.",
                },
                {
                    id: "b",
                    text: "Mandás una campaña a los socios de esa sede ofreciendo un descuento.",
                },
                {
                    id: "c",
                    text: "Esperás a la alerta de la noche siguiente para ver si se repite.",
                },
                {
                    id: "d",
                    text: "Abrís el reporte de ese día y esa sede, buscás qué lo explica y revisás el cierre de caja.",
                },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, cuando te llega una alerta abrís el reporte de ese día y esa sede, te fijás si hubo algo que lo explique, como una clase cancelada o un corte, y revisás el cierre de caja del turno.",
        },
        // ── reportes.alertas-seguridad ──────────────────────────────────────────
        {
            id: "reportes.alertas-seguridad#1",
            lessonKey: "reportes.alertas-seguridad",
            prompt: "Te llega una alerta: una recepcionista anuló un cobro. ¿Qué hacés primero?",
            options: [
                {
                    id: "a",
                    text: "La llamás enseguida para pedirle explicaciones delante del equipo.",
                },
                {
                    id: "b",
                    text: "Abrís su línea de auditoría y leés el motivo que escribió.",
                },
                {
                    id: "c",
                    text: "Le sacás el permiso de anular cobros hasta revisarlo.",
                },
                {
                    id: "d",
                    text: "Apagás esa alerta para que no vuelva a molestar por anulaciones chicas.",
                },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, cuando te llega una no saques conclusiones apuradas: abrí la línea de auditoría y leé el motivo que se escribió. Muchas veces tiene una explicación simple; si no, hablá con la persona.",
        },
        {
            id: "reportes.alertas-seguridad#2",
            lessonKey: "reportes.alertas-seguridad",
            prompt: "Sos coordinador intersedes y querés subir el umbral de descuento del 10 % al 15 %. ¿Podés?",
            options: [
                {
                    id: "a",
                    text: "Sí, porque podés activar y apagar las alertas.",
                },
                {
                    id: "b",
                    text: "Sí, pero sólo para las sedes que coordinás.",
                },
                {
                    id: "c",
                    text: "Sí, si escribís un motivo que quede en la auditoría.",
                },
                {
                    id: "d",
                    text: "No: podés prender o apagar, pero los umbrales de plata son sólo del Dueño.",
                },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, el Dueño y el coordinador intersedes pueden activar o apagar cada alerta, pero los umbrales de plata los ajusta sólo el Dueño.",
        },
        {
            id: "reportes.alertas-seguridad#3",
            lessonKey: "reportes.alertas-seguridad",
            prompt: "Apagás la alerta de descuentos y al día siguiente alguien hace un descuento del 30 %. ¿Qué queda de ese descuento?",
            options: [
                {
                    id: "a",
                    text: "Nada: con la alerta apagada, la acción tampoco se registra.",
                },
                {
                    id: "b",
                    text: "Queda en el historial de disparos, marcado como silenciado.",
                },
                {
                    id: "c",
                    text: "Queda igual en la auditoría; sólo que nadie recibe el aviso.",
                },
                {
                    id: "d",
                    text: "El sistema no deja hacer descuentos mientras la alerta esté apagada.",
                },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, apagar una alerta no borra nada: la acción igual queda en la auditoría, sólo que nadie recibe el aviso. Por eso conviene pensarlo dos veces: es un aviso menos.",
        },
        {
            id: "reportes.alertas-seguridad#4",
            lessonKey: "reportes.alertas-seguridad",
            prompt: "¿Por qué estas alertas avisan en el momento en que pasa la acción, y no en un reporte al día siguiente?",
            options: [
                {
                    id: "a",
                    text: "Porque son acciones que mueven plata o cambian reglas: están permitidas, pero tienen que verse.",
                },
                {
                    id: "b",
                    text: "Porque esas acciones están prohibidas y el aviso sirve para frenarlas antes de que se completen.",
                },
                {
                    id: "c",
                    text: "Porque al día siguiente la auditoría ya borró el detalle de la acción.",
                },
                {
                    id: "d",
                    text: "Porque el aviso deshace la acción si el Dueño no la aprueba en el día.",
                },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, anular un cobro, hacer un descuento grande o cambiar un precio están permitidos, pero tienen que verse. Estas alertas avisan en el momento en que pasan, para que cada peso tenga dueño y todos trabajen tranquilos.",
        },
        // ── reportes.auditoria ──────────────────────────────────────────────────
        {
            id: "reportes.auditoria#1",
            lessonKey: "reportes.auditoria",
            prompt: "Querés saber por qué se anuló ayer el cobro de Juana Prueba en Olivos. ¿Cómo lo buscás en la auditoría?",
            options: [
                {
                    id: "a",
                    text: "Exportás toda la auditoría del año y lo buscás en la planilla.",
                },
                {
                    id: "b",
                    text: "Filtrás por superficie molinete, que es donde se registran los cobros.",
                },
                {
                    id: "c",
                    text: "Elegís la sede y la fecha, y marcás Sólo excepciones.",
                },
                {
                    id: "d",
                    text: "Le preguntás a recepción, porque la auditoría no guarda el motivo.",
                },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, elegís la sede, la fecha y marcás Sólo excepciones: ahí está quién la anuló, a qué hora y con qué motivo. La anulación de un cobro es una excepción.",
        },
        {
            id: "reportes.auditoria#2",
            lessonKey: "reportes.auditoria",
            prompt: "Un dato se cargó mal y el Dueño quiere que esa línea desaparezca de la auditoría. ¿Qué se puede hacer?",
            options: [
                {
                    id: "a",
                    text: "Corregirlo con una acción nueva, que queda al lado de la original.",
                },
                {
                    id: "b",
                    text: "Borrar la línea: el Dueño es el único rol que puede hacerlo.",
                },
                {
                    id: "c",
                    text: "Editar la línea para dejar el dato correcto, con un motivo.",
                },
                {
                    id: "d",
                    text: "Pedirle a Administración que la oculte de la lista.",
                },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, no hay pantalla, rol ni permiso que edite o borre una línea, ni siquiera el Dueño. Si algo estuvo mal, se corrige con una acción nueva que queda al lado de la original, y así la historia siempre está completa.",
        },
        {
            id: "reportes.auditoria#3",
            lessonKey: "reportes.auditoria",
            prompt: "Abrís en la auditoría el cambio de PIN de un usuario. ¿Qué ves del PIN?",
            options: [
                {
                    id: "a",
                    text: "El PIN anterior y el nuevo, para poder comparar.",
                },
                {
                    id: "b",
                    text: "Sólo el PIN nuevo, porque el anterior ya no sirve.",
                },
                {
                    id: "c",
                    text: "El PIN, pero sólo si sos el Dueño.",
                },
                {
                    id: "d",
                    text: "Nada: el sistema tapa los PIN antes de guardar.",
                },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, el detalle muestra el antes, el después y el contexto, pero las contraseñas, los PIN y los códigos nunca aparecen: el sistema los tapa antes de guardar.",
        },
        {
            id: "reportes.auditoria#4",
            lessonKey: "reportes.auditoria",
            prompt: "Exportás en CSV la auditoría de un trimestre entero para revisarla tranquilo. ¿Qué pasa con esa exportación?",
            options: [
                {
                    id: "a",
                    text: "Nada: exportar es sólo leer, así que no deja rastro.",
                },
                {
                    id: "b",
                    text: "Queda auditada y, si es muy grande, dispara la alerta de exportación masiva.",
                },
                {
                    id: "c",
                    text: "Queda auditada, pero sólo si la hace alguien que no sea el Dueño.",
                },
                {
                    id: "d",
                    text: "No se puede: la auditoría sólo se mira en pantalla.",
                },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, con Exportar CSV te llevás lo que estás viendo, y la exportación también queda auditada. Si es muy grande, dispara la alerta de exportación masiva.",
        },
    ],
};
//# sourceMappingURL=reportes.js.map